import { TimeInMilliseconds } from ':constants/time';

export const exponentialBackoffDelay = (retryCount: number, baseDelayInMs = 15 * TimeInMilliseconds.SECOND): number =>
    2 ** retryCount * baseDelayInMs;
